import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ExcludedPartner } from 'src/app/assabil-sales/models/dtos/excluded-partner';

@Component({
  selector: 'excluded-partner',
  templateUrl: './excluded-partner.component.html',
  styleUrls: ['./excluded-partner.component.scss']
})
export class ExcludedPartnerComponent implements OnInit {

  @Input() geoArea    ;
  @Input() excludedPartner : ExcludedPartner;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod      : string;

  
  constructor(protected datepipe: DatePipe) { }

  ngOnInit() {
  }


  clickTitle()    { this.onClick.emit({partnerclusterCode : this.excludedPartner.partnerclusterCode, geoArea : this.geoArea, kpi : "Count"} );} 
  clickExcluded() { this.onClick.emit({partnerclusterCode : this.excludedPartner.partnerclusterCode, geoArea : this.geoArea, kpi : "Excluded"} );} 

  getExcludedPartnerRate(excludedPartner : ExcludedPartner) {
    return Math.round((excludedPartner.totalCount !=0 ? (excludedPartner.excludedPartnerCount * 100 / excludedPartner.totalCount) : 0));
  }

}